import { Component, OnInit, Injector } from '@angular/core';
import { userProfileModal } from '../userProfile/userProfile.component';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../../services/data/data.service';

@Component({
  selector: 'mobile-user-profile-modal',
  template: require('./mobile-user-profile-modal.component.html'),
  styles: [require('./mobile-user-profile-modal.component.css')]
})
export class MobileUserProfileModalComponent extends userProfileModal {

  constructor(
    injector: Injector,
    protected router: Router,
    public activeModal: NgbActiveModal,
    public dataService: DataService
  ) 
  {
      super(injector, router, activeModal, dataService);
  }

}
